const FacebookIconReduced = ({ color }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.0271 14.602C29.0271 6.53743 22.5291 -0.000205994 14.5135 -0.000205994C6.49792 -0.000205994 0 6.53743 0 14.602C0 21.8904 5.30739 27.9314 12.2458 29.0269V18.823H8.56072V14.602H12.2458V11.385C12.2458 7.72528 14.4126 5.70379 17.7278 5.70379C19.3157 5.70379 20.9766 5.98899 20.9766 5.98899V9.5825H19.1465C17.3435 9.5825 16.7813 10.7081 16.7813 11.8629V14.602H20.8065L20.163 18.823H16.7813V29.0269C23.7197 27.9314 29.0271 21.8904 29.0271 14.602Z"
        fill="#1877F2"
      />
    </svg>
  );
};

export default FacebookIconReduced;
